import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        // Don't retry on 4xx errors except 401
        if (
          error?.status !== undefined &&
          error.status >= 400 &&
          error.status < 500 &&
          error.status !== 401
        ) {
          return false;
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false
    },
    mutations: {
      retry: false
    }
  }
});
